function getUrlVars() {
  var vars = [],
    hash;
  var hashes = window.location.href
    .slice(window.location.href.indexOf("?") + 1)
    .split("&");
  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split("=");
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }
  return vars;
}

jQuery(document).ready(function () {
  //click on step2 config
  $(".step2_config, .next_step2").click(function () {
    if ($("input[name='delivery_time']:checked").length > 0) {
      var variant_title = $("input[name='order_config_varient']:checked").val();
      //console.log(variant_title);
      var variantqtyS = $("input[name='order_config_varient']:checked").attr(
        "quantity-id"
      );
      var qtyElement = $(".config_qty");
      var qrtTxtElement = $(".qrt_txt");
      qtyElement.text(`Qty: ` + variantqtyS);
      qrtTxtElement.text(variant_title);

      $(this).addClass("active");
      $(".sub_step2_config").css("display", "block");
      $(".step1_config").removeClass("active");
      $(".sub_step1_config").css("display", "none");
      $(".step2_config").css("pointer-events", "auto");
    } else {
      //alert("Please select all the options");
      return false;
    }
  });

  // //click on step3 config
  $(".step3_config, .next_step3").click(function () {
    // alert('ok');
    // $(".custom_order").css("pointer-events", "auto");
    // $(".custom_order").css("background-color", "#dc2626");
    // let isAnyFilled = false; // Flag variable to check if any input is filled

    // $(".quantity").each(function() {
    //   if ($(this).val() !== '') {
    //     isAnyFilled = true; // Set the flag to true if any input is filled
    //     return false; // Exit the loop since we already found a filled input
    //   }
    // });

    // if (isAnyFilled) {
    $(".quantity.active").removeClass("active");
    $(".sub_step3_config").css("display", "block");
    $(".step2_config").removeClass("active");
    $(".sub_step2_config").css("display", "none");
    $(".step3_config").css("pointer-events", "auto");
    // } else {
    //   alert("None of the options are checked");
    // }
  });

  //click on decoratead_type

  $('input[name="decorated_type"]').on("change", function () {
    var decorated_type = $(this).val();
    console.log(decorated_type);
    if (decorated_type == "blank") {
      $(".custom_order").css("pointer-events", "auto");
      $(".custom_order").css("background-color", "#dc2626");
      $(".step4_config").css("display", "none");
      $(".step5_config").css("display", "none");
      $(".step6_config").css("display", "none");
      $(".step7_config").css("display", "none");
      $(".sub_step4_config").css("display", "none");
      $(".sub_step6_config").css("display", "none");
      $(".sub_step7_config").css("display", "none");
    } else {
      $(".custom_order").css("pointer-events", "none");
      $(".custom_order").css("background-color", "#dc26265c");
      $(".step4_config").css("display", "block");
      $(".step4_config").css("pointer-events", "auto");
      $(".step5_config").css("display", "block");
      $(".step6_config").css("display", "block");
      $(".step7_config").css("display", "block");
      $(".sub_step4_config").css("display", "none");
      $(".sub_step6_config").css("display", "none");
      $(".sub_step7_config").css("display", "none");
    }
  });

  $('input[name="decoration_method"]').on("change", function () {
    $("input[name='decoration_method']:not(:checked)").each(function () {
      var decoration_method_class = $(this).attr("decoration-location");
      console.log(decoration_method_class);
      $("." + decoration_method_class).css("display", "none");
    });

    if ($("input[name='decoration_method']:checked").length > 0) {
      var decoration_method = $("input[name='decoration_method']:checked").attr(
        "decoration-location"
      );
      $("." + decoration_method).css("display", "block");
      $(".sub_step3_config").css("display", "none");
      $(".sub_step4_config").css("display", "none");
      $(".sub_step6_config").css("display", "block");
      $(".step6_config").css("pointer-events", "auto");
    }
  });

  $('input[name="decoration_location"]').on("change", function () {
    $(".sub_step6_config").css("display", "none");
    $(".sub_step7_config").css("display", "block");

    $(".step6_config").removeClass("active");
  });

  $(".step7_config").click(function () {
    $(".sub_step4_config").css("display", "none");
    $(".sub_step6_config").css("display", "none");
    $(".step4_config").removeClass("active");
    $(".step6_config").removeClass("active");
  });

  $('input[name="add_art"]').on("change", function () {
    if ($("input[name='add_art']:checked").length > 0) {
      var add_art = $(this).val();
      $(".sub_step5_config").css("display", "none");
      $(".sub_step6_config").css("display", "block");
      $(".step6_config").css("pointer-events", "auto");
    }
  });

  $('input[name="decoration_location"]').on("change", function () {
    if ($("input[name='decoration_location']:checked").length > 0) {
      var decoration_location = $(this).val();
      if (decoration_location == "custom_heigh_and_width") {
        $(".custom_height_width").removeAttr("disabled");
      } else {
        $(".custom_height_width").attr("disabled", true);
      }
      $(".custom_order").css("pointer-events", "auto");
      $(".custom_order").css("background-color", "#dc2626");
    }
  });

  $(".quantity").on("change", function () {
    $(".custom_order").css("pointer-events", "auto");
    $(".custom_order").css("background-color", "#dc2626");

    var quantity = $(this).val();
    var price = $("#variant-select")
      .children("option")
      .filter(":selected")
      .attr("data-price");
    var totalPrice = quantity * price;
    $("#total-price").text(totalPrice.toFixed(2));
  });

  $("#max_qty").on("change", function () {
    if ($("input[name='order_sample_varient']:checked").length > 0) {
      var variantId = $("input[name='order_sample_varient']:checked").data(
        "id"
      );
      var quantity = parseInt(
        $(this).children("option").filter(":selected").val(),
        10
      );

      var price = parseFloat(
        $("input[name='order_sample_varient']:checked").data("price")
      );
      var totalPrice = quantity * price;
      $("#total_price_sample").text(totalPrice.toFixed(2));
      $(".sample_cart").css("pointer-events", "auto");
      $(".sample_cart").css("background-color", "#dc2626");
      if ($(this).children("option").filter(":selected").val() == "") {
        $(".sample_cart").css("pointer-events", "none");
        $(".sample_cart").css("background-color", "#dc26265c");
      }
    } else {
      alert("Please Select a color");
      return false;
    }
  });

  $('input[name="Size"]').on("change", function () {
    var checkedValues = [];
    $('input[name="Size"]:checked').each(function () {
      checkedValues.push($(this).val());
    });
    var variantId = $("input[name='order_sample_varient']:checked").val();
    var combinedValues = checkedValues.map(function (size) {
      return variantId + " / " + size;
    });
    var variantSelect = $("#variant-select");

    var subtotal = 0; // Initialize subtotal to zero
    combinedValues.forEach(function (combinedValue) {
      var matchingOption = variantSelect.find(
        'option[data-name="' + combinedValue + '"]'
      );
      if (matchingOption.length > 0) {
        var dataPrice = parseFloat(matchingOption.attr("data-price")); // Parse the price as a float

        subtotal += dataPrice;
      } else {
        console.log("No matching data-name found for:", combinedValue);
      }
    });
    $("#total_price_sample").text(subtotal.toFixed(2));
  });

  $(".step4_config").click(function () {
    $(".sub_step3_config").css("display", "none");
    $(".sub_step6_config").css("display", "none");
    $(".sub_step7_config").css("display", "none");
    $(".step3_config").removeClass("active");
  });

  $(".step6_config").click(function () {
    $(".sub_step4_config").css("display", "none");
    $(".sub_step7_config").css("display", "none");
    $(".step4_config").removeClass("active");
    var decoration_method = $("input[name='decoration_method']:checked").attr(
      "decoration-location"
    );
    $("input[name='decoration_method']:not(:checked)").each(function () {
      var decoration_method_class = $(this).attr("decoration-location");
      console.log(decoration_method_class);
      $("." + decoration_method_class).css("display", "none");
    });
    $("." + decoration_method).css("display", "block");
    $(".custom_order").css("pointer-events", "auto");
    $(".custom_order").css("background-color", "#dc2626");
  });

  $(".inside_tab_varient").click(function () {
    var targetValue = $(this).attr("data-value");
    $(".color-label").text(targetValue);

    $("input:radio[name=inside_tab_varient]")
      .filter('[value="' + targetValue + '"]')
      .prop("checked", true);
    $("input:radio[name=order_config_varient]")
      .filter('[value="' + targetValue + '"]')
      .prop("checked", true);
    $("input:radio[name=order_sample_varient]")
      .filter('[value="' + targetValue + '"]')
      .prop("checked", true);
  });
  $(".color-label").text($("input[name='inside_tab_varient']:checked").val());
});

// Create virtual tab****************************************************************

$(".step2_virtual, .next_step2_virtual").click(function () {
  if (
    $("input[name='virtual_varient']:checked").length > 0 &&
    $("input[name='delivery_time_virtual']:checked").length > 0
  ) {
    $(this).addClass("active");
    $(".sub_step2_virtual").css("display", "block");
    $(".step1_virtual").removeClass("active");
    $(".sub_step1_virtual").css("display", "none");
    $(".step2_virtual").css("pointer-events", "auto");
  } else {
    alert("Please select all the options");
    return false;
  }
});

//tabs

function openTab1(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent1");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
    tabcontent[i].className = tabcontent[i].className.replace("tab-cart", "");
  }
  tablinks = document.getElementsByClassName("tablinks1");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  var element = document.getElementById(cityName);
  element.classList.add("tab-cart");
  evt.currentTarget.className += " active";
}

function openTab2(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent2");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks2");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}
//accordion

var acc = document.getElementsByClassName("accordion");
var j;

for (j = 0; j < acc.length; j++) {
  acc[j].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

function order_cart(variant_id) {
  //setup fee
  var setupFeeId = "8174820098272";
  var sureshipFeeId = "8157592486112";

  //sureship 44329218113760
  var sureship = $("input[name='delivery_time']:checked").val();
  if (sureship == "sureship") {
    sureship = "Sureship";
  } else {
    sureship = "Standard lead time";
  }
  var decoration_type = $('input[name="decorated_type"]:checked').val();
  var decoration_method = $('input[name="decoration_method"]:checked').val();
  var decoration_location = $(
    'input[name="decoration_location"]:checked'
  ).val();
  var logo_upload = $('input[name="attributes[upload]"]').val();
  //for size
  var sizeData = {};
  $(".size-config").each(function () {
    var id = $(this).attr("id");
    var value = $(this).val();
    sizeData[id] = value;
  });

  var variantName = $("input[name='order_config_varient']:checked").val();

  // var items = [];
  if (decoration_type != "decorated" && sureship != "Sureship") {
    var items = [];
  } else if (decoration_type == "decorated" && sureship != "Sureship") {
    var items = [
      {
        quantity: "1",
        id: "44377517949152",
        properties: {
          [`_${variant_id}`]: true,
        },
      },
    ];
  } else if (decoration_type != "decorated" && sureship == "Sureship") {
    var items = [
      {
        quantity: "1",
        id: "44329218113760",
        properties: {
          [`_${variant_id}`]: true,
        },
      },
    ];
  } else {
    var items = [
      {
        quantity: "1",
        id: "44377517949152",
        properties: {
          [`_${variant_id}`]: true,
        },
      },
      {
        quantity: "1",
        id: "44329218113760",
        properties: {
          [`_${variant_id}`]: true,
        },
      },
    ];
  }

  // if(sureship == 'sureship'){
  //     var items = [{quantity: "1",
  //               id: "44329218113760",
  //               properties: {
  //                   [`_${variant_id}`]: true
  //               }}];
  // } else {
  // var items = [];
  // }

  for (var id in sizeData) {
    if (sizeData.hasOwnProperty(id)) {
      var quantity = sizeData[id];

      if (quantity !== null && quantity !== "") {
        // Check for null or empty quantity
        var combinedValue = variantName + " / " + id;
        var matchingOption = $(
          '#variant-select option[data-name="' + combinedValue + '"]'
        );

        if (matchingOption.length > 0) {
          var variantID = matchingOption.val();

          if (decoration_type == "blank") {
            var item = {
              quantity: parseInt(quantity),
              id: parseInt(variantID),
              properties: {
                "How fast do you need this? ": sureship,
                "Decoration Type: ": "Blank",
              },
            };
          } else {
            var item = {
              quantity: parseInt(quantity),
              id: parseInt(variantID),
              properties: {
                "How fast do you need this? ": sureship,
                "Decoration Type: ": "Decorated",
                "Decoration Method: ": decoration_method,
                "Decoration Location: ": decoration_location,
                "Logo: ": logo_upload,
              },
            };
          }

          items.push(item);
        } else {
          console.log("No matching data-name found for:", combinedValue);
        }
      }
    }
  }

  console.log(items);

  //for qty
  var varient = $("#variant-select")
    .children("option")
    .filter(":selected")
    .val();
  var quantity = $("input[name='quantity']").val();

  if (Object.keys(sizeData).length === 0) {
    if (decoration_type == "blank") {
      var send_items = {
        quantity: quantity,
        id: varient,
        properties: {
          "How fast do you need this? ": sureship,
          "Decoration Type: ": "Blank",
        },
      };
    } else {
      var send_items = {
        quantity: quantity,
        id: varient,
        properties: {
          "How fast do you need this? ": sureship,
          "Decoration Type: ": "Decorated",
          "Decoration Method: ": decoration_method,
          "Decoration Location: ": decoration_location,
          "Logo: ": logo_upload,
        },
      };
    }
    items.push(send_items);
    //for qty

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { items: items },

      dataType: "json",
      success: function (data) {
        updateCartCount();
        window.location.href = "https://cfdfpromo.com/cart";
      },
    });
  } else {
    //for size
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { items: items },
      dataType: "json",
      success: function (data) {
        updateCartCount();
        window.location.href = "https://cfdfpromo.com/cart";
      },
      error: function (error) {
        console.error("Error:", error);
      },
    });
  }
}

//sample_cart
function order_sample_cart(variant_id) {
  //for qty
  var varient = $("input[name='order_sample_varient']:checked").attr("data-id");
  var quantity = $("#max_qty").children("option").filter(":selected").val();

  //for size
  var allSize = [];
  $('input[name="Size"]:checked').each(function () {
    allSize.push($(this).val());
  });
  var variantName = $("input[name='order_sample_varient']:checked").val();
  var combinedValues = allSize.map(function (size) {
    return variantName + " / " + size;
  });
  var variantSelect = $("#variant-select");
  var items = [];

  combinedValues.forEach(function (combinedValue) {
    var matchingOption = variantSelect.find(
      'option[data-name="' + combinedValue + '"]'
    );
    if (matchingOption.length > 0) {
      var varientID = matchingOption.val();
      var item = {
        quantity: 1,
        id: parseInt(varientID),
      };
      items.push(item);
    } else {
      console.log("No matching data-name found for:", combinedValue);
    }
  });
  console.log(allSize);

  if (allSize.length == 0) {
    //for qty
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: quantity,
        id: varient,
      },
      dataType: "json",
      success: function (data) {
        //console.log(data)
        updateCartCount();
        window.location.href = "https://cfdfpromo.com/cart";
      },
      error: function (error) {
        console.error("Error:", error);
      },
    });
  } else {
    //for size
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { items: items }, // Send the items array in the data
      dataType: "json",
      success: function (data) {
        // Handle success
        updateCartCount();
        window.location.href = "https://cfdfpromo.com/cart";
      },
      error: function (error) {
        // Handle error
        console.error("Error:", error);
      },
    });
  }
}

$(document).on("click", ".calculate-quantities-button", function () {
  $(".size-config").each(function () {
    var id = $(this).attr("id");
    var quantityDisplay = $(this).siblings(".display_qty_here"); // Get the display quantity element
    var variantSelect = $("#variant-select");
    var variantName = $("input[name='order_config_varient']:checked").val();
    var combinedValue = variantName + " / " + id;
    var matchingOption = variantSelect.find(
      'option[data-name="' + combinedValue + '"]'
    );
    if (matchingOption.length > 0) {
      var dataQuantity = parseInt(matchingOption.attr("data-quantity"));
      quantityDisplay.text("Qty: " + dataQuantity);
    } else {
      console.log("No matching data-name found for:", combinedValue);
    }
  });
});

$(document).on("keyup", ".size-config", function () {
  var total = 0; // Initialize total to zero
  $(".size-config").each(function () {
    var id = $(this).attr("id");
    var quantity = $(this).val(); // Get the quantity entered in the input field
    var variantSelect = $("#variant-select");
    var variantName = $("input[name='order_config_varient']:checked").val();
    var combinedValue = variantName + " / " + id;
    var matchingOption = variantSelect.find(
      'option[data-name="' + combinedValue + '"]'
    );

    if (matchingOption.length > 0) {
      var dataPrice = parseFloat(matchingOption.attr("data-price")); // Get the price from the selected option

      if (!isNaN(quantity)) {
        total += dataPrice * quantity; // Add to the total
      }
    } else {
      console.log("No matching data-name found for:", combinedValue);
    }
  });

  // Update the UI with the calculated total
  $("#total-price").text(total.toFixed(2));
});
//update cart values
function updateCartCount() {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cart) {
      var cartItems = cart.items;
      var cartCount = 0;
      // Calculate the cart count, excluding specific product IDs
      cartItems.forEach(function (item) {
        console.log(item);
        if (item.id != 44377517949152 && item.id != 44329218113760) {
          cartCount += item.quantity;
        }
      });
      $("#cart-count").text(cartCount);
      $("#cart-count-m").text(cartCount);
    },
  });
}


